<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_ii"></a>CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/02_Chapter01">I. A GENTLEMAN OF THE RANGE.</a></h2>
<h2 class="toc"><a href="#/xhtml/03_Chapter02">II. A SECRET KEPT.</a></h2>
<h2 class="toc"><a href="#/xhtml/04_Chapter03">III. SISTER AND BROTHER.</a></h2>
<h2 class="toc"><span href="#/xhtml/05_Chapter04" title="Link target outside of Sample">IV. A RIDE FROM SUNRISE TO SUNSET.</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter05" title="Link target outside of Sample">V. THE ROUND UP.</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter06" title="Link target outside of Sample">VI. A GIFT AND A PURCHASE.</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter07" title="Link target outside of Sample">VII. HER MAJESTY’S RANCHO.</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter08" title="Link target outside of Sample">VIII. EL CAPITAN.</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter09" title="Link target outside of Sample">IX. THE NEW FOREMAN.</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter10" title="Link target outside of Sample">X. DON CARLOS’S VAQUEROS.</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter11" title="Link target outside of Sample">XI. A BAND OF GUERRILLAS.</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter12" title="Link target outside of Sample">XII. FRIENDS FROM THE EAST.</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter13" title="Link target outside of Sample">XIII. COWBOY GOLF.</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter14" title="Link target outside of Sample">XIV. BANDITS.</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter15" title="Link target outside of Sample">XV. THE MOUNTAIN TRAIL.</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter16" title="Link target outside of Sample">XVI. THE CRAGS.</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter17" title="Link target outside of Sample">XVII. THE LOST MINE OF THE PADRES.</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter18" title="Link target outside of Sample">XVIII. BONITA.</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter19" title="Link target outside of Sample">XIX. DON CARLOS.</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter20" title="Link target outside of Sample">XX. THE SHERIFF OF EL CAJON.</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter21" title="Link target outside of Sample">XXI. UNBRIDLED.</span></h2>
<h2 class="toc"><a id="page_iii"></a><span href="#/xhtml/23_Chapter22" title="Link target outside of Sample">XXII. THE SECRET TOLD.</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter23" title="Link target outside of Sample">XXIII. THE LIGHT OF THE WESTERN STARS.</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Chapter24" title="Link target outside of Sample">XXIV. THE RIDE. “STILLWELL!”.</span></h2>
<h2 class="toc"><span href="#/xhtml/26_Chapter25" title="Link target outside of Sample">XXV. AT THE END OF THE ROAD.</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?057b21d8